module.exports = __webpack_public_path__ + "static/media/upload-game-illustration.2b5981f3.png";